import { render, staticRenderFns } from "./bulma_timeline.vue?vue&type=template&id=3c2259f1&scoped=true&lang=html"
import script from "./bulma_timeline.vue?vue&type=script&lang=js"
export * from "./bulma_timeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2259f1",
  null
  
)

export default component.exports